export default __webpack_public_path__ + "static/media/aloha-lake.0d48fd19.jpg";